function _(r,n,o){var t=r(40);n.exports=function(r){if(!t(r))throw new TypeError(r+" is not a symbol");return r}}
//# sourceMappingURL=validate-symbol.min.js.map